<script lang="ts">
  /**
   * When combining uiform and Workflow, use WorkflowFooter as a direct replacement
   * for FooterButtons that also displays the "base" error (when present) below the 
   * Step content and before the footer.
   */
  import type { ComponentProps } from "svelte";
  import FooterButtons from "../workflow/FooterButtons.svelte";
  import FieldError from "./FieldError.svelte";

  let {
    errorName = "base",
    ...rest
  } : { errorName?: string } & ComponentProps<typeof FooterButtons> = $props();
</script>
<FieldError name={errorName} class="ui-error" />
<FooterButtons {...rest} />